<template>
<div>
  <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <p class="letra10" v-for="coordinador in data.item.asignaciones" :key="data.item.pti + coordinador.nombreCoordinador" 
    :value="coordinador.nombreCoordinador">
            {{ coordinador.nombreCoordinador}} <br/>
        
    </p>
</div> 
</template>

<script>
export default {
    name: "AsignacionesPtiAltoRiesgoPacienteComponente",
    props: {
        data: Object,
        resource: Object
    },
    data: () => ({
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,
    }),
    created() {
      this.debug = this.$localStorageService.getDebug();
    },
    methods: {
 
    }
}
</script>
